import React from 'react'

const RoleCard = () => {
  return (
    <>
        <div className="col-12 col-md-4 mb-3">
            <div className="card rounded-0">
                <div className="card-header p-3 pb-0">
                    <div className="d-flex align-items-center">
                        <h6 className="text-uppercase mb-0">System setting</h6>
                    </div>
                </div>
                <div className="card-body p-3">
                    <div className="table-responsive">
                        <table className="table align-items-center mb-0 border">
                        <thead className="bg-dark">
                            <tr>
                                <td >
                                    <div className="form-check form-check-info text-start mb-0">
                                        <input className="form-check-input mb-0" type="checkbox" value="" id="flexCheckDefault" />
                                        <label className="form-check-label mb-0 text-white" for="flexCheckDefault">User</label>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="form-check form-check-info text-start mb-0">
                                        <input className="form-check-input mb-0" type="checkbox" value="" id="flexCheckDefault" checked/>
                                        <label className="form-check-label mb-0" for="flexCheckDefault">I agree the</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="form-check form-check-info text-start mb-0">
                                        <input className="form-check-input mb-0" type="checkbox" value="" id="flexCheckDefault" />
                                        <label className="form-check-label mb-0" for="flexCheckDefault">I agree the</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="form-check form-check-info text-start mb-0">
                                        <input className="form-check-input mb-0" type="checkbox" value="" id="flexCheckDefault" />
                                        <label className="form-check-label mb-0" for="flexCheckDefault">I agree the</label>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default RoleCard